require('./hireCardViaTSuccess.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');
const { formatAmountObject } = require('utilities/currencyHelper');
const { getLastNChars } = require('utilities/stringHelper');
const HireSuccessStepCardImage = require('components/cards/hireSuccessStepCardImage/hireSuccessStepCardImage');

//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKMessage } = require('commonsComponents/OKMessage');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

// @constants
const { PENDING } = require('constants/hireCardSubmitScenarios');
const {
    CARD_PAYMENT_METHOD_UNIQUE,
    CARD_PAYMENT_METHOD_FIXED,
    CARD_PAYMENT_METHOD_VARIABLE,
    EURO_SYMBOL,
    EURO_TEXT,
    PERCENTAGE_SYMBOL
} = require('constants/index');
const { analyticsId, catalogue } = require('../analytics/hireCardViaTAnalytics');

class hireCardViaTSuccess extends React.Component {

    buildSummary() {
        const {
            immAccount,
            immHireCreditLimit,
            immHirePaymentMethod
        } = this.props;

        const limitObj = {
            amount: immHireCreditLimit.get('creditLimit'),
            currency: EURO_TEXT
        };

        const paymentMethod = {
            [CARD_PAYMENT_METHOD_UNIQUE]: `${formatText('hireCardViaT-summaryMethodOfPaymentFullPay')}`,
            [CARD_PAYMENT_METHOD_FIXED]: `${formatText('hireCardViaT-summaryMethodOfPaymentDeferredFixedFee')}`,
            [CARD_PAYMENT_METHOD_VARIABLE]: `${formatText('hireCardViaT-summaryMethodOfPaymentDeferredVariableFee')}`
        };

        const paymentMethodType = immHirePaymentMethod.get('type');
        const paymentMethodText = paymentMethod[paymentMethodType];
        const paymentMethodSymbol = paymentMethodType === CARD_PAYMENT_METHOD_FIXED ? EURO_SYMBOL : PERCENTAGE_SYMBOL;
        const paymentMethodValue = paymentMethodType === CARD_PAYMENT_METHOD_UNIQUE
            ? paymentMethodText
            : `${paymentMethodText} ${immHirePaymentMethod.get('value')} ${paymentMethodSymbol}`;

        const accountIban = getLastNChars(immAccount.get('iban'));

        return (
            <div className="row hire-card-via-t-success__summary">
                <div className="col-xs-6 hire-card-via-t-success__summary-left-column">
                    <FormattedText
                        className="col-xs-12 hire-card-via-t-success__summary-title"
                        value="hireCardViaT-summarySelectedLimit"
                    />
                    <OneLineSymbolAmount
                        amountObject={limitObj}
                        amountObjectFormatted={formatAmountObject(limitObj, true)}
                        className="col-xs-12 hire-card-via-t-success__summary-value"
                        language={getLanguage()}
                        trimDecimals={true}
                    />
                    <FormattedText
                        className="col-xs-12 hire-card-via-t-success__summary-title"
                        value="cardDetails-associatedAccount"
                    />
                    <div className="col-xs-12 hire-card-via-t-success__summary-value">
                        {`${immAccount.get('alias')} ${accountIban}`}
                    </div>
                </div>
                <div className="col-xs-5 col-xs-offset-1">
                    <FormattedText
                        className="col-xs-12 hire-card-via-t-success__summary-title"
                        value="hireCardViaT-summaryPaymentMethod"
                    />
                    <div className="col-xs-12 hire-card-via-t-success__summary-value">
                        {paymentMethodValue}
                    </div>
                </div>
            </div>
        );
    }

    buildTexts() {
        const { immHireCardViaT, immShippingAddress } = this.props;
        let textElement;
        let titleKey;

        const pendingAnalysis = immHireCardViaT.get('hiringStatus') === PENDING;

        if (pendingAnalysis) {
            titleKey = 'hireCardViaT-successTitlePending';
            textElement = (
                <div className="col-xs-8 hire-card-via-t-success__text">
                    <FormattedText value="hireCardViaT-successText1Pending" />
                </div>
            );
        } else {
            const address = PersonalDataHelper.getHireFormattedAddress(immShippingAddress);

            titleKey = 'hireCardViaT-successTitleCompleted';
            textElement = (
                <div className="col-xs-8 hire-card-via-t-success__text">
                    <FormattedText value="hireCardViaT-successText1Completed" />
                    <div className="hire-card-via-t-success__address">
                        <i className="hire-card-via-t-success__address-icon icon icon-s-locacion" />
                        {address}
                    </div>
                </div>
            );
        }

        return {
            textElement,
            titleKey
        };
    }

    buildMessage() {
        const { immProfile } = this.props;
        const email = PersonalDataHelper.getEmail(immProfile);
        const textKey = !!email ? 'successWarningTextSentByEmail' : 'successWarningTextUpdateEmail';
        const injectedString = [
            ...(!!email ? [email] : [])
        ];
        return (
            <div className="col-xs-12">
                <OKMessage type="informative">
                    <FormattedText
                        value={`hireCardViaT-${textKey}`}
                        injectedStrings={injectedString}
                    />
                </OKMessage>
            </div>
        );
    }

    render() {
        const {
            immHireCardImageSelector,
            immHireCardViaT,
            immProfile,
            processDetail
        } = this.props;
        let content;

        if (immProfile.get('isFetching')) {
            content = <LoadingSection />;
        } else {
            const { textElement, titleKey } = this.buildTexts();
            const messageSection = this.buildMessage();
            const summarySection = this.buildSummary();
            const selectedImageId = immHireCardImageSelector.get('selectedImageId');
            const immImageData = immHireCardImageSelector.getIn(['imagesById', selectedImageId]);
            const wizardSuccessIcon = immHireCardViaT.get('hiringStatus') === PENDING ? 'pending' : '';

            const goBackButton = {
                label: (
                    <FormattedText
                        format="uppercase"
                        value="hireCardViaT-successBackButtonText"
                    />
                ),
                url: '/myprofile/cards'
            };

            content = (
                <WizardSuccess
                    iconModifier={wizardSuccessIcon}
                    mainButton={goBackButton}
                    processDetail={processDetail}
                    successMessage={formatText(titleKey)}
                    tealium={catalogue[analyticsId.VIA_T_CARD_WIZARD_SUCCESS]({ productName: processDetail })}
                    isSecondVersion
                >
                    <article className="hire-card-via-t-success">
                        <div className="row">
                            <HireSuccessStepCardImage
                                className="col-xs-4 hire-card-via-t-success__card-image"
                                immImageData={immImageData}
                            />
                            {textElement}
                        </div>
                        {summarySection}
                        <div className="row hire-card-via-t-success__message">
                            {messageSection}
                        </div>
                    </article>
                </WizardSuccess>
            );
        }
        return content
    }
}

hireCardViaTSuccess.propTypes = {
    immAccount: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardViaT: PropTypes.object.isRequired,
    immHireCreditLimit: PropTypes.object.isRequired,
    immHirePaymentMethod: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immShippingAddress: PropTypes.object.isRequired,
    processDetail: PropTypes.string
};

module.exports = hireCardViaTSuccess;
